// src/pages/ContentDetail/components/activity/ActivityContent.js
import React from 'react';
import FluencyActivity from './FluencyActivity';
import DecodeActivity from './DecodeActivity';
import VocabularyActivity from './VocabularyActivity';
import ComprehensionActivity from './ComprehensionActivity';
import { Typography } from '@mui/material';

const ActivityContent = ({ activity }) => {
  
  switch (activity.type) {
    case 'FLUENCY':
      return <FluencyActivity activity={activity} />;
    case 'DECODE':
      return <DecodeActivity activity={activity} />;
    case 'VOCABULARY':
      return <VocabularyActivity activity={activity} />;
    case 'COMPREHENSION':
      return <ComprehensionActivity activity={activity} />;
    default:
      return <Typography color="text.primary">Unsupported activity type</Typography>;
  }
};

export default ActivityContent;